export default __webpack_public_path__ + "static/media/landscape14.97a70f7f.jpeg";